var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/vip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 44.9999648 0 44.9999648 47.9999652 0 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-1006.000000, -777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/vip",
    transform: "translate(1006.000000, 777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999648,47.9999652 L22.4999648,47.9999652 C10.0736367,47.9999652 -3.515625e-05,38.0333565 -3.515625e-05,25.7390957 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,25.7390957 C44.9999648,38.0333565 34.926293,47.9999652 22.4999648,47.9999652",
    id: "Fill-1",
    fill: "#1A1A1A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999648,44.5217043 L22.4999648,44.5217043 C10.0736367,44.5217043 -3.515625e-05,34.5550957 -3.515625e-05,22.2608348 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,22.2608348 C44.9999648,34.5550957 34.926293,44.5217043 22.4999648,44.5217043",
    id: "Fill-4",
    fill: "#666666",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.669375,17.3722435 L24.2704688,12.1809391 C23.4390234,10.9110261 21.5609766,10.9110261 20.7295313,12.1809391 L17.330625,17.3722435 L14.1194531,15.2755478 C13.0461328,14.5746783 11.6634375,15.549287 11.9826563,16.7819826 L14.6759766,27.1885913 C14.9150391,28.1120696 15.7559766,28.7579826 16.7196094,28.7579826 L22.5,28.7579826 L28.2807422,28.7579826 C29.2440234,28.7579826 30.0849609,28.1120696 30.3240234,27.1885913 L33.0173438,16.7819826 C33.3365625,15.549287 31.9538672,14.5746783 30.8805469,15.2755478 L27.669375,17.3722435 Z",
    id: "Fill-7",
    fill: "#D6E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.669375,17.3722435 L24.2704687,12.1809391 C23.8545703,11.5461565 23.1774609,11.2285913 22.5,11.2285913 L22.5,28.7579826 L28.2807422,28.7579826 C29.2440234,28.7579826 30.0849609,28.1120696 30.3240234,27.1885913 L33.0173438,16.7819826 C33.3365625,15.549287 31.9538672,14.5746783 30.8805469,15.2755478 L27.669375,17.3722435 Z",
    id: "Fill-9",
    fill: "#B6C4CE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7812148,-3.47826087e-05 L4.21871484,-3.47826087e-05 C1.88891016,-3.47826087e-05 -3.515625e-05,1.86883478 -3.515625e-05,4.17387826 L-3.515625e-05,22.2608348 C-3.515625e-05,34.5550957 10.0736367,44.5217043 22.4999648,44.5217043 C34.926293,44.5217043 44.9999648,34.5550957 44.9999648,22.2608348 L44.9999648,4.17387826 C44.9999648,1.86883478 43.1110195,-3.47826087e-05 40.7812148,-3.47826087e-05 M40.7812148,4.17387826 L40.7812148,22.2608348 C40.7812148,32.2340522 32.5803164,40.3477913 22.4999648,40.3477913 C12.4196133,40.3477913 4.21871484,32.2340522 4.21871484,22.2608348 L4.21871484,4.17387826 L40.7812148,4.17387826",
    id: "Fill-11",
    fill: "#4D4D4D",
    mask: "url(#mask-6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.3a49d666f817d0d9d4d9215ebf891bac.svg";
export { ForwardRef as ReactComponent };